import HttpService from "./http.service";

class RestaurantService extends HttpService {
    list = (params) => this.get("restaurant/list-restuarants", params); 

    listAllRestaurantsWithBranches = () => this.get("restaurant/list-all-restaurants-with-branches"); 

    listLanguage = () =>this.getlanguage("getAllLanguageDetails");

    managePost = (params) => this.post("restaurant/add-resturant-gallery", params); 

    updatePost = (params,restaurantId) => this.patch(`restaurant/update-resturant/${restaurantId}`,params);

    //manageSeo = (params) => this.post("cms/manage-seo", params);  

    // getSeo = (params) => this.get("cms/get-seo", params); 
 
}

export default new RestaurantService();